var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,{tag:"component",staticClass:"baseButton",class:[
    _vm.properties.variant,
    _vm.properties.size,
    {fullwidth: _vm.properties.fullwidth},
    {loader: _vm.loading},
    ( _obj = {}, _obj[_vm.properties.attentionSeeker] = _vm.properties.attentionSeeker !== 'none', _obj ) ]},[_c('span',_vm._b({staticClass:"text"},'span',_vm.textProps,false),[_c('BaseText',{attrs:{"prop":[_vm.prop, 'text'].filter(function (e) { return e; }).join('.'),"content":_vm.properties.text,"options":{
        singleLine: true,
        link: false,
      }}}),(_vm.properties.icon)?_c('i',{staticClass:"c-icon",class:("icon-" + (_vm.properties.icon))}):_vm._e()],1),(_vm.properties.subtext)?_c('span',{staticClass:"subtext"},[_c('BaseText',{attrs:{"prop":[_vm.prop, 'subtext'].filter(function (e) { return e; }).join('.'),"content":_vm.properties.subtext,"options":{
        singleLine: true,
        link: false,
      }}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }